import { useState } from 'react';
import { usePatientProfile } from '../../ProfileBar/hooks';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import type { InvitePatientPayload } from '../types';
import { post } from '../../../../api/baseUrl';
import { MyPainHealthUserStatus } from '../../../../lib';

export const useInviteMyPainHealthPatient = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const {
    patientProfile,
    patientMyPainHealthUserStatus,
    setPatientMyPainHealthUserStatus,
  } = usePatientProfile();
  const [phone, setPhone] = useState(patientProfile.phone || '');

  const openInviteMyPainHealthModal = () => {
    setPhone(patientProfile.phone || '');
    setShowModal(true);
  };
  const closeInviteMyPainHealthModal = () => setShowModal(false);

  const onSendInviteMyPainHealthPatient = async (normalized?: string) => {
    const patientAccessToken = patientProfile?.access_token;
    if (!patientAccessToken || !selectedTenancy)
      return { success: false, data: null };
    try {
      setLoading(true);
      const requestBody: InvitePatientPayload = {
        access_token: patientAccessToken,
        tenancyId: Number(selectedTenancy.tenancy_id),
        phone: normalized ?? phone,
      };
      const result = await post<{
        message: string;
        data: MyPainHealthUserStatus;
      }>('inviteMyPainHealthPatient', requestBody);
      if (!result || !result.data) return { success: false, data: null };

      setPatientMyPainHealthUserStatus({
        created: !!result.data.data.created,
        onboarded: !!result.data.data.onboarded,
        active: !!result.data.data.active,
      });
      return { success: true, data: result.data.data };
    } catch (error) {
      console.error('Error inviting patient:', error);
      return { success: false, data: null };
    } finally {
      setLoading(false);
      closeInviteMyPainHealthModal();
    }
  };
  return {
    loading,
    showModal,
    patientMyPainHealthUserStatus,
    phone,
    setPhone,
    openInviteMyPainHealthModal,
    closeInviteMyPainHealthModal,
    onSendInviteMyPainHealthPatient,
  };
};
